import { render } from "./CertificateAdd.vue?vue&type=template&id=02609336&scoped=true"
import script from "./CertificateAdd.vue?vue&type=script&lang=js"
export * from "./CertificateAdd.vue?vue&type=script&lang=js"

import "./CertificateAdd.vue?vue&type=style&index=0&id=02609336&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02609336"]])

export default __exports__